import axios from 'axios';

interface IEnvironmentConfiguration {
    diLoginAuthority: string;
    emailDomain: string;
    selfServiceAuthority: string;
}

let configuration: IEnvironmentConfiguration | null = null;

export default async function getConfiguration() {
    if (configuration !== null) {
        return configuration;
    }
    
    const conf = window.localStorage.getItem("conf");
    
    if (conf) {
        return JSON.parse(conf);
    }

    configuration = (await axios.get('/api/configuration')).data as IEnvironmentConfiguration;

    window.localStorage.setItem("conf", JSON.stringify(configuration));

    return configuration;
}